export const hexToRgb = (hex: string) => {
	const bigInt = parseInt(hex.substring(1), 16)
	var r = (bigInt >> 16) & 255
	var g = (bigInt >> 8) & 255
	var b = bigInt & 255

	return [r, g, b].join(',')
}
